<template>
  <div class="container mescroll-touch">
    <mescroll-vue ref="mescroll" :down="mescrollDown" :up="mescrollUp" @init="mescrollInit">
      <div class="banner">
        <van-swipe ref="banner" class="elbanner" autoplay="5000" indicator-active-color="#FFFFFF">
          <van-swipe-item v-for="item in list.Banner" :key="item.BannerId">
            <img :src="item.CoverUrl" class="bannerimg" @click="toBanner(item.LinkUrl, item.BannerId)" />
          </van-swipe-item>
        </van-swipe>
      </div>

      <div class="modeltitle" v-if="dklist.length != 0">
        <span class="modelname">打卡签到</span>
        <span class="gzmore" @click="opengz()">规则</span>
      </div>

      <div class="tcout" v-if="showtc == 1">
        <div class="tcimg">
          <div class="jumptc">
            <img :src="baseURL + list.Alais.Rules" class="tcimgin" />
          </div>
          <div class="konwclose" @click="closebtn()">
            我知道了
            <!-- <img src="../../assets/images/tcclose.png" class="tcimgin" /> -->
          </div>
        </div>

        <div class="back"></div>
      </div>

      <div class="tcout" v-if="showdkcg == 1">
        <div class="tcimg">
          <div class="jumptc">
            <img :src="baseURL + tkimg" class="tcimgin" />
          </div>
          <div class='successmore' @click="tomorecg()">更多活动，点击查看</div>
          <div class="close" @click="closecg()">
            <img src="../../assets/images/tcclose.png" class="tcimgin" />
          </div>
        </div>

        <div class="back"></div>
      </div>

      <div class="gz_consult" v-if="dklist.length != 0">
        <div class="gz_consult_box">
          <div class="gz_consult_item" v-for="(item, index) in dklist" :key="index" @click="djqd(item)">
            <div class="gztanchaung1">
              <div class="gzpicture">
                <img src="../../assets/images/notdk.png" alt="" class="dkimg" v-if="item.Status == 0">
                <img src="../../assets/images/isdk.png" alt="" class="dkimg" v-else>
                <img :src="baseURL + item.ImgUrl" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modeltitle" v-if="list.Alais.AliasVideo1 && list.Video1">
        <span class="modelname">{{ list.Alais.AliasVideo1 }}</span>
        <span class="modelmore" @click="tovdlist(1)">更多></span>
      </div>
      <div class="square_consult" v-if="list.Video1">
        <div class="square_consult_box">
          <div class="right_Consult1" v-for="(item, index) in list.Video1" :key="index"
            @click="toVideo(item.ArticleId, item.VideoUrl)">
            <div class="livetiaozhuan">
              <div class="picture">
                <!-- <img src="../../assets/images/play.png" alt="" class="play"> -->
                <img :src="baseURL + item.CoverUrl" />
              </div>
              <div class="base">
                <div class="title van-multi-ellipsis--l2">
                  {{ item.Title }}
                </div>
                <div class="time">{{ item.CreateTime }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modeltitle" v-if="list.Alais.AliasVideo2 && list.Video2">
        <span class="modelname">{{ list.Alais.AliasVideo2 }}</span>
        <span class="modelmore" @click="tovdlist(2)">更多></span>
      </div>
      <div class="square_consult" v-if="list.Video2">
        <div class="square_consult_box">
          <div class="right_Consult1" v-for="(item, index) in list.Video2" :key="index"
            @click="toVideo(item.ArticleId, item.VideoUrl)">
            <div class="livetiaozhuan">
              <div class="picture">
                <!-- <img src="../../assets/images/play.png" alt="" class="play"> -->
                <img :src="baseURL + item.CoverUrl" />
              </div>
              <div class="base">
                <div class="title van-multi-ellipsis--l2">
                  {{ item.Title }}
                </div>
                <div class="time">{{ item.CreateTime }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modeltitle" v-if="list.Alais.AliasVideo3 && list.Video3">
        <span class="modelname">{{ list.Alais.AliasVideo3 }}</span>
        <span class="modelmore" @click="tovdlist(3)">更多></span>
      </div>
      <div class="square_consult" v-if="list.Video3">
        <div class="square_consult_box">
          <div class="right_Consult1" v-for="(item, index) in list.Video3" :key="index"
            @click="toVideo(item.ArticleId, item.VideoUrl)">
            <div class="livetiaozhuan">
              <div class="picture">
                <!-- <img src="../../assets/images/play.png" alt="" class="play"> -->
                <img :src="baseURL + item.CoverUrl" />
              </div>
              <div class="base">
                <div class="title van-multi-ellipsis--l2">
                  {{ item.Title }}
                </div>
                <div class="time">{{ item.CreateTime }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modeltitle" v-if="list.Alais.AliasVideo4 && list.Video4">
        <span class="modelname">{{ list.Alais.AliasVideo4 }}</span>
        <span class="modelmore" @click="tovdlist(4)">更多></span>
      </div>
      <div class="square_consult" v-if="list.Video4">
        <div class="square_consult_box">
          <div class="right_Consult1" v-for="(item, index) in list.Video4" :key="index"
            @click="toVideo(item.ArticleId, item.VideoUrl)">
            <div class="livetiaozhuan">
              <div class="picture">
                <!-- <img src="../../assets/images/play.png" alt="" class="play"> -->
                <img :src="baseURL + item.CoverUrl" />
              </div>
              <div class="base">
                <div class="title van-multi-ellipsis--l2">
                  {{ item.Title }}
                </div>
                <div class="time">{{ item.CreateTime }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modeltitle" v-if="list.Alais && list.Live">
        <span class="modelname">{{ list.Alais.LiveName }}</span>
        <span class="modelmore" @click="toslivelist(fxtit, list.Alais.LiveName, fximg)">更多></span>
      </div>
      <div class="square_consult" v-if="list.Live">
        <div class="square_consult_box">
          <div class="right_Consult" v-for="(item, index) in list.Live" :key="index"
            @click="toLive(item.ArticleId, item.LiveUrl, item.StatusStr)">
            <div class="livetiaozhuan1">
              <div class="picture">
                <!-- <img src="../../assets/images/play.png" alt="" class="play"> -->
                <img :src="baseURL + item.CoverUrl" />
              </div>
              <div class="base">
                <div class="title van-multi-ellipsis--l2">
                  {{ item.Title }}
                </div>
                <div class="yyout">
                  <div class="time yytime">{{ item.StartTime }}</div>
                  <div class="yytype">
                    <button class="yybtn" @click.stop="yybtnfunc(item.ArticleId)"
                      v-if="item.StatusStr == '未开始' && item.IsReservation == false">预约</button>
                    <button class="yybtndisable" @click.stop="qxyybtnfunc(item.ArticleId)"
                      v-if="item.StatusStr == '未开始' && item.IsReservation == true">取消预约</button>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modeltitle" v-if="list.Alais && list.Collection">
        <span class="modelname">{{ list.Alais.CollectionName }}</span>
        <span class="modelmore" @click="tosctlist(fxtit, list.Alais.CollectionName, fximg)">更多></span>
      </div>
      <div class="square_consult" v-if="list.Collection">
        <div class="square_consult_box">
          <div class="right_Consult1" v-for="(item, index) in list.Collection" :key="index"
            @click="toCollection(item.CollectionId, item.DetfaultLessonId)">
            <div class="livetiaozhuan">
              <div class="picture">
                <!-- <img src="../../assets/images/play.png" alt="" class="play"> -->
                <img :src="baseURL + item.CoverUrl" />
              </div>
              <div class="base">
                <div class="title van-multi-ellipsis--l2">
                  {{ item.Title }}
                </div>
                <div class="time">{{ item.CreateTime }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="atitle">
        <div class="modeltitle1" :class="modtitact == 1 ? 'modtitact' : ''"
          v-if="list.Alais.ArticleName && showatitle != 0" @click="modtit1()">
          <span class="modelname">{{ list.Alais.ArticleName }}</span>
          <!-- <span class="modelmore">更多<span class="jt">></span></span> -->
        </div>
        <div class="modeltitle1" :class="modtitact == 2 ? 'modtitact' : ''" v-if="list.Alais.ArticleName2"
          @click="modtit2()">
          <span class="modelname">{{ list.Alais.ArticleName2 }}</span>
          <!-- <span class="modelmore">更多<span class="jt">></span></span> -->
        </div>
        <div class="modeltitle1" :class="modtitact == 3 ? 'modtitact' : ''" v-if="list.Alais.ArticleName3"
          @click="modtit3()">
          <span class="modelname">{{ list.Alais.ArticleName3 }}</span>
          <!-- <span class="modelmore">更多<span class="jt">></span></span> -->
        </div>
      </div>
      <div class="square_consult" v-if="artlist">
        <div class="square_consult_box">
          <div class="right_Consult" v-for="(item, index) in artlist" :key="index" @click="toArticle(item)">
            <div class="livetiaozhuan1">
              <div class="picture">
                <!-- <img src="../../assets/images/play.png" alt="" class="play"> -->
                <img :src="baseURL + item.CoverUrl" />
              </div>
              <div class="base">
                <div class="title van-multi-ellipsis--l2">
                  {{ item.Title }}
                </div>
                <div class="time">{{ item.CreateTime }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </mescroll-vue>

    <!-- <img class="share" src="../../assets/images/circle_share.png" @click="showSharePanel = true" /> -->

    <div v-if="gocheck == true" class="check1">
      <div class="checkback"></div>
      <div class="checkkuang">
        <div class="checkicon"><img src="../../assets/images/checkicon.png" alt="" class="con"></div>
        <div class="checktitle">提醒</div>
        <div class="checkinner">感谢关注！本内容仅对专业人士开放，请先完成对应的注册！</div>
        <div class="btrowi">
          <div class="clo" @click="gocheck = false">取消</div>
          <div class="jum" @click="gohfh()">去注册</div>
        </div>
      </div>
    </div>

    <div v-if="gocheck1 == true" class="check1">
      <div class="checkback"></div>
      <div class="checkkuang">
        <div class="checkicon"><img src="../../assets/images/checkicon.png" alt="" class="con"></div>
        <div class="checktitle">提醒</div>
        <div class="checkinner">感谢关注!本内容仅对ACMED会员开放，请您登录后验证身份，谢谢!</div>
        <div class="btrowi">
          <div class="clo" @click="gocheck1 = false">取消</div>
          <div class="jum" @click="goacmedzc()">去验证</div>
        </div>
      </div>
    </div>

    <div v-if="gocheck2 == true" class="check1">
      <div class="checkback"></div>
      <div class="checkkuang">
        <div class="checkicon"><img src="../../assets/images/checkicon.png" alt="" class="con"></div>
        <div class="checktitle">提醒</div>
        <div class="checkinner">感谢关注！本内容仅对华肤荟认证用户开放，请您登录后验证身份，谢谢！</div>
        <div class="btrowi">
          <div class="clo" @click="gocheck2 = false">取消</div>
          <div class="jum" @click="goacmedrz()">去验证</div>
        </div>
      </div>
    </div>

    <div v-if="gocheck3 == true" class="check1">
      <div class="checkback"></div>
      <div class="checkkuang">
        <div class="checkicon"><img src="../../assets/images/checkicon.png" alt="" class="con"></div>
        <div class="checktitle">提醒</div>
        <div class="checkinner">感谢关注!本内容仅对特定用户开放，请您输入手机号验证身份后观看，谢谢!</div>
        <div class="checkinput">
          <el-input v-model="phone" class="cheinpt" placeholder="请输入您的手机号"></el-input>
        </div>
        <div class="btrowi">
          <div class="clo" @click="gocheck3 = false">取消</div>
          <div class="jum1" @click="upphone()">提交</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from '../../common/mixin/mixins'
import BScroll from 'better-scroll'
import MescrollVue from 'mescroll.js/mescroll.vue'
export default {
  name: 'program',
  data() {
    return {
      baseURL: process.env.VUE_APP_BASE_URL,
      details: {},
      constab: 1,
      SubjectTCode: 1,
      list: [],
      artlist: [],
      PageIndex: 0,
      PageSize: 10,
      mescroll: null, // mescroll实例对象
      mescrollDown: {
        use: false,
        isLock: false
      },
      mescrollUp: { // 上拉加载的配置.
        isBounce: false,
        callback: this.upCallback, // 上拉回调
        page: {
          num: 0, //当前页 默认0,回调之前会加1; 即callback(page)会从1开始
          size: 10 //每页数据条数,默认10
        },
        noMoreSize: 0,
        toTop: {
          // warpId: 'toTop',
          src: './static/image/top_comm_icon@2x.png' // 回到顶部按钮的图片路径,支持网络图
        }
      },
      showSharePanel: false,
      listword: "",
      subList: [],
      bannerlist: [],
      canshu: "",
      gocheck: false,
      gocheck1: false,
      gocheck2: false,
      gocheck3: false,
      bmdid: "",
      phone: "",
      fxtit: '',
      fximg: '',
      modtitact: 1,
      dklist: [],
      dkisnon: '',
      showtc: 0,
      showdkcg: 0,
      dknow: '',
      showatitle: 0,
      tkimg: '',
    }
  },
  mixins: [mixin],
  components: {
    MescrollVue,
  },
  computed: {
    code() {
      return this.$route.query.code;
    },
    tcode() {
      return this.$route.query.tcode;
    },
  },
  watch: {
    SubjectTCode() {
      this.list = [];
      this.dklist = [];
      this.mescroll.resetUpScroll() // 刷新列表数据
    },
    // 监听路由的变化
    $route(to, from) {
      // 判断：如果当前是目标页面，且来源页面不是当前页面（说明是从外部跳进来的）
      if (to.path === from.path) return;
      // console.log('检测到路由返回，正在强制重载页面...');
      // 核心：强制刷新整个浏览器页面，重置所有状态和事件绑定
      if (!to.query.dkid) {
        console.log('检测到从其他页面返回，正在强制重载页面...');
        window.location.reload();
      }
    }

  },
  created() {
    document.title = this.$route.query.tit ? this.$route.query.tit : '华肤荟专区';
    this.yanzheng();
    this.getfximg();
    this.getBanner();
    this.getall();
    // this.getsub();
    this.$store.commit("changeNavbarIndex", 2);
    if (this.code) {
      this.getColumn();
    }
  },
  activated() {
    if (this.$route.query.dkid) {
      this.backdk();
    } else {
      // 从 informationDetails 等其他页面返回，确保弹窗关闭
      this.showdkcg = 0;
      this.showtc = 0;
    }
  },
  methods: {
    getfximg() {
      let that = this
      that.$axios.get('/api/api/web/section/GetModel?id=' + this.$route.query.id).then(res => {
        that.fximg = res.Data.Cover;
        that.fxtit = res.Data.Title;
        // console.log(that.fximg)
        // console.log(that.fxtit)
        if (this.fxtit && this.fximg) {
          this.initzqShare(this.fxtit, '权威 专业 赋能——您身边的皮肤科链接圈', this.fximg);
        } else {
          this.initzqShare('华肤荟专区', '权威 专业 赋能——您身边的皮肤科链接圈');
        }
      })
    },
    getall() {
      let that = this;
      that.$axios.get('/api/api/web/section/IndexContent', {
        params: {
          SectionId: this.$route.query.id
        }
      }).then(res => {
        that.list = res.Data;
        if (that.list.Alais.ArticleName) {
          that.modtitact = 1
        } else {
          if (that.list.Alais.ArticleName2) {
            that.modtitact = 2
          } else {
            if (that.list.Alais.ArticleName3) {
              that.modtitact = 3
            }
          }
        }

        that.$axios.post('/api/api/web/section/SectionSignList', {
          SectionId: this.$route.query.id
        }).then(rrs => {
          that.dklist = rrs.Data.List
          console.log('↓')
          console.log(that.dklist)
        })
      })

    },
    yanzheng() {
      let that = this
      this.$axios.get(`/api/api/web/section/CheckPermission?SectionId=${this.$route.query.id}`).then(res => {
        if (res.Data.CheckPermission == true) {
          that.gochek = false
          that.gochek1 = false
          that.gochek2 = false
          that.gochek3 = false
        } else {
          if (res.Data.AllowHFHRegUser == true) {
            that.gocheck = true
          } else {
            if (res.Data.AllowACMEDUser == true) {
              that.gocheck1 = true
            } else {
              if (res.Data.AllowHFHIdUser == true) {
                that.gocheck2 = true
              } else {
                if (res.Data.AllowWhiteList == true && !this.$route.query.isbmd) {
                  that.gocheck3 = true
                } else {
                  that.gocheck3 = false
                }
              }
            }
          }
        }
      })
    },
    gohfh() {
      this.gocheck = false;
      this.gocheck1 = false;
      this.gocheck2 = false;
      this.gocheck3 = false;
      const userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
      if (userInfo && userInfo.Status < 30) {
        this.$router.push({
          path: 'login',
          query: {
            isbackdk: '1',
            dkid: this.dknow.Id
          }
        });
      }
      else if (userInfo && userInfo.Status < 40) {
        this.$router.push({
          path: 'compinfo',
          query: {
            isbackdk: '1',
            dkid: this.dknow.Id
          }
        });
      }
    },
    goacmedzc() {
      let that = this;
      this.gocheck = false;
      this.gocheck1 = false;
      this.gocheck2 = false;
      this.gocheck3 = false;
      this.$axios.get("/api/api/web/Customer/GetMyInfo").then((res) => {
        if (res.Data.ACMEDIdentity) {
          this.$router.push({
            path: "/newenterin"
          });
        } else {
          this.$router.push({
            path: '/acmedonly'
          });
        }
      });
    },
    goacmedrz() {
      this.gocheck = false;
      this.gocheck1 = false;
      this.gocheck2 = false;
      this.gocheck3 = false;
      this.$axios.get("/api/api/web/Customer/GetMyInfo").then((res) => {
        if (res.Data.HFHIdentity == '' || res.Data.HFHIdentity == null) {
          this.$router.push({
            path: 'renzhenginfo'
          });
        } else if (res.Data.HFHIdentity != '' && res.Data.HFHIdentity != null && res.Data.HFHIdentity.Status == 0) {
          this.$dialog
            .alert({
              title: "提示",
              message: "认证审核中，请耐心等待",
            })
            .then(() => { });
        }
      });
    },
    upphone() {
      let that = this
      this.$axios.post('/api/api/web/section/CheckWhiteList', {
        SectionId: this.$route.query.id,
        Mobile: this.phone,
      }).then(res => {
        if (res.Data == false) {
          this.$message({
            showClose: true,
            message: '暂无权限，请稍后再试',
            type: 'error'
          });
        } else {
          that.gocheck3 = false
        }
      })
    },
    getBanner() {
      let that = this
      this.$axios.get('/api/api/web/content/LiveBannerList?subjectTCode=section|').then(res => {
        that.bannerlist = res.Data;
        console.log()
      })
    },
    // getsub() {
    //   this.$axios.get('/api/api/web/content/LiveSubjectRecommendList').then(res => {
    //     this.subList = res.Data;
    //     console.log(this.subList)
    //   })
    // },
    toBanner(url, id) {
      let that = this
      this.$axios
        .post("/api/api/web/BuriedPoint/AddBP", {
          BPType: 2,
          Name: '专区Banner',
          TCode: 'section_banner',
          Rid: id,
          UpId: that.$route.query.id
        }).then(res => {
          location.href = url;
        })
    },
    initBScroll() {
      this.$nextTick(() => {
        this.scroll = new BScroll(this.$refs['wrapper'], {
          startX: 0,
          click: true,
          scrollX: true,
          scrollY: false,
          eventPassthrough: 'vertical'
        })
      })
    },
    getColumn() {
      this.$axios.get(`/api/api/web/content/SubjectDetail?code=${this.code}`).then(res => {
        this.details = res.Data;
        this.initBScroll();
        // this.initShare(this.details.Title);
      })
    },
    // getList(PageIndex, PageSize) {
    //   let that = this;
    //   that.PageIndex = PageIndex;
    //   that.PageSize = PageSize;
    //   that.$axios.get('/api/api/web/section/IndexContent?SectionId=' + this.$route.query.id).then(res => {
    //     const newData = res.Data;
    //     // that.list = res.Data;
    //     if (PageIndex === 1) {
    //       that.list = { ...newData };
    //     } else {
    //       that.list.Article = that.list.Article.concat(newData.Article);
    //     }
    //     that.$nextTick(() => {
    //       that.mescroll.endSuccess(newData.Article.length)
    //     })
    //     console.log(that.list)
    //   })
    // },
    getList(PageIndex, PageSize) {
      const that = this;
      that.PageIndex = PageIndex;
      that.PageSize = PageSize;

      that.$axios.post('/api/api/web/section/SectionArticleList', {
        SectionId: this.$route.query.id,
        PageIndex: PageIndex,
        PageSize: PageSize,
        ContentArticleTab: that.modtitact
      }).then(res => {
        if (that.modtitact == 1) {
          that.showatitle = res.Data.Total
          console.log(res.Data.Total)
        }
        const newData = res.Data.List || [];

        if (PageIndex === 1) {
          that.artlist = [...newData];
        } else {
          if (that.artlist && newData) {
            that.artlist = that.artlist.concat(newData);
          }
        }

        that.$nextTick(() => {
          that.mescroll.endSuccess(newData ? newData.length : 0);
        });
      }).catch(err => {
        console.error('加载失败', err);
        that.mescroll.endErr();
      });
    },
    modtit1() {
      let that = this
      that.modtitact = 1
      this.mescroll.resetUpScroll()
    },
    modtit2() {
      let that = this
      that.modtitact = 2
      this.mescroll.resetUpScroll()
    },
    modtit3() {
      let that = this
      that.modtitact = 3
      this.mescroll.resetUpScroll()
    },
    yybtnfunc(id) {
      let that = this;
      this.$axios.post('/api/api/web/content/LiveReservation', {
        ArticleId: id
      }).then(res => {
        this.$dialog
          .alert({
            title: "提示",
            message: "预约成功！",
          })
          .then(() => {
            that.getall()
          });
      })
    },
    qxyybtnfunc(id) {
      let that = this;
      this.$axios.post('/api/api/web/content/LiveReservationCancel', {
        ArticleId: id
      }).then(res => {
        this.$dialog
          .alert({
            title: "提示",
            message: "取消预约成功！",
          })
          .then(() => {
            that.getall()
          });
      })
    },
    // mescroll组件初始化的回调,可获取到mescroll对象
    mescrollInit(mescroll) {
      this.mescroll = mescroll  // 如果this.mescroll对象没有使用到,则mescrollInit可以不用配置
    },
    getsearchword() {
      this.getList(1, 10);
    },
    // 上拉回调
    upCallback(page) {
      this.getList(page.num, page.size);
    },
    toztmore() {
      this.$router.push({
        path: 'ztmoreList',
      });
    },
    toclass(num) {
      this.constab = num
      this.PageIndex = 0
      this.mescrollUp.page.num = 0
      this.list = [];
      this.upCallback(this.mescrollUp.page)
    },
    toDetail(info) {
      console.log('跳转详情')
      if (info.isOuterChain) {
        location.href = info.outerChain;
      } else {
        this.$router.push({
          path: 'informationDetails',
          query: {
            code: info.Code
          }
        });
      }
    },
    toLive(id, lurl, str) {
      if (str == '已结束') {
        this.$axios
          .post("/api/api/web/BuriedPoint/AddBP", {
            BPType: 2,
            Name: '资讯点击',
            TCode: 'article',
            Rid: id,
          }).then(res => {
            this.$router.push({
              path: 'live',
              query: {
                id: lurl,
                type: '2',
                articleId: id,
              }
            });
          })
      } else {
        this.$axios
          .post("/api/api/web/BuriedPoint/AddBP", {
            BPType: 2,
            Name: '资讯点击',
            TCode: 'article',
            Rid: id,
          }).then(res => {
            this.$router.push({
              path: 'live',
              query: {
                id: lurl,
                type: '1',
                articleId: id,
              }
            });
          })
      }
      // console.log("tz")
    },
    toCollection(id, aid) {
      this.$axios
        .post("/api/api/web/BuriedPoint/AddBP", {
          BPType: 2,
          Name: '资讯点击',
          TCode: 'article',
          Rid: aid,
        }).then(res => {
          this.$router.push({
            path: 'programvod',
            query: {
              id: id,
              aid: aid,
            }
          });
        })
      // console.log("tz")
    },
    toVideo(aid, url) {
      this.$axios
        .post("/api/api/web/BuriedPoint/AddBP", {
          BPType: 2,
          Name: '观看视频',
          TCode: 'article',
          Rid: aid,
        }).then(res => {
          window.location.href = url
        })
      // console.log("tz")
    },
    toArticle(info) {
      // console.log("tz")
      if (info.IsOuter) {
        this.$axios
          .post("/api/api/web/BuriedPoint/AddBP", {
            BPType: 2,
            Name: '资讯点击',
            TCode: 'article',
            Rid: info.ArticleId,
          }).then(res => {
            location.href = info.OuterUrl;
          })
      } else {
        this.$axios
          .post("/api/api/web/BuriedPoint/AddBP", {
            BPType: 2,
            Name: '资讯点击',
            TCode: 'article',
            Rid: info.ArticleId,
          }).then(res => {
            this.$router.push({
              path: "informationDetails",
              query: {
                code: info.ArticleCode,
              },
            });
          })
      }
    },
    closeSharePanel() {
      this.showSharePanel = false;
    },
    guanzhufunc(id, iw) {
      let that = this;
      this.$axios.get('/api/api/web/content/WatchSubject?id=' + id).then(res => {
        console.log(res)
        if (res.RetCode == 10000) {
          if (iw == true) {
            this.$dialog
              .alert({
                title: "提示",
                message: "取关成功！",
              })
              .then(() => {
                this.getsub();
              });
          } else if (iw == false) {
            this.$dialog
              .alert({
                title: "提示",
                message: "关注成功！",
              })
              .then(() => {
                this.getsub();
              });
          }
        } else {
          this.$dialog
            .alert({
              title: "提示",
              message: "操作失败，请稍后再试",
            })
            .then(() => {
            });
        }
      })
    },
    toslivelist(tit, stit, img) {
      if (this.$route.query.isbmd) {
        this.$router.push({
          path: 'sectionlivelist',
          query: {
            id: this.$route.query.id,
            isbmd: '1',
          }
        });
      } else {
        this.$router.push({
          path: 'sectionlivelist',
          query: {
            id: this.$route.query.id,
          }
        });
      }

    },
    tosctlist(tit, stit, img) {
      if (this.$route.query.isbmd) {
        this.$router.push({
          path: 'sectionctlist',
          query: {
            id: this.$route.query.id,
            isbmd: '1',
          }
        });
      } else {
        this.$router.push({
          path: 'sectionctlist',
          query: {
            id: this.$route.query.id,
          }
        });
      }
    },
    tovdlist(tab) {
      this.$router.push({
        path: 'sectionvdlist',
        query: {
          id: this.$route.query.id,
          ContentArticleTab: 4,
          ContentVideoGroup: tab
        }
      });

    },
    opengz() {
      let that = this;
      this.$axios
        .post("/api/api/web/BuriedPoint/AddBP", {
          BPType: 2,
          Name: '专区规则',
          TCode: 'section_rules',
          UpId: that.$route.query.id
        }).then(res => {
          this.showtc = 1;
        })
    },
    closebtn() {
      this.showtc = 0;
    },
    closecg() {
      this.showdkcg = 0;
      this.getall();
      if (this.$route.query.dkid || this.$route.query.isbackdk) {
        this.$router.replace({
          query: { ...this.$route.query, dkid: undefined, isbackdk: undefined }
        });
      }
    },
    djqd(item) {
      let that = this
      that.dknow = item
      const userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
      if (item.Switch == 0) {
        console.log('dom.stop')
      } else {
        if (userInfo && userInfo.Status < 40) {
          this.$axios
            .post("/api/api/web/BuriedPoint/AddBP", {
              BPType: 2,
              Name: '打卡签到',
              TCode: 'section_sign',
              Rid: item.Id,
              UpId: that.$route.query.id
            }).then(res => {
              that.gocheck = true
            })
        } else {
          this.$axios
            .post("/api/api/web/BuriedPoint/AddBP", {
              BPType: 2,
              Name: '打卡签到',
              TCode: 'section_sign',
              Rid: item.Id,
              UpId: that.$route.query.id
            }).then(res => {
              this.$axios
                .post("/api/api/web/section/CheckSectionSign", {
                  SectionSignId: item.Id
                }).then(res => {
                  that.tkimg = item.PopImgUrl
                  that.showdkcg = 1;
                })
            })
        }
      }
    },
    backdk() {
      let that = this
      if (this.$route.query.dkid) {
        this.$axios
          .post("/api/api/web/BuriedPoint/AddBP", {
            BPType: 2,
            Name: '注册返回打卡',
            TCode: 'section_sign_register',
            Rid: this.$route.query.dkid,
            UpId: that.$route.query.id,
          }).then(res => {
            this.$axios
              .post("/api/api/web/section/CheckSectionSign", {
                SectionSignId: this.$route.query.dkid
              }).then(res => {
                that.showdkcg = 1
                // this.$router.replace({
                //   query: { ...this.$route.query, dkid: undefined, isbackdk: undefined }
                // });
              })
          })
      }
    },
    tomorecg() {
      let that = this
      this.showtc = 0
      this.showdkcg = 0
      if (that.dknow.LinkUrl) {
        this.$axios
          .post("/api/api/web/BuriedPoint/AddBP", {
            BPType: 2,
            Name: '打卡详情外链',
            TCode: 'section_sign_url',
            Rid: 0,
            UpId: that.dknow.Id
          }).then(res => {
            this.gocheck = false
            this.gocheck1 = false
            this.gocheck2 = false
            this.gocheck3 = false
            this.$router.replace({
              query: { ...this.$route.query, dkid: undefined, isbackdk: undefined }
            });
            location.href = that.dknow.LinkUrl;
          })
      } else {
        this.$axios
          .post("/api/api/web/BuriedPoint/AddBP", {
            BPType: 2,
            Name: '打卡详情内链',
            TCode: 'section_sign_article',
            Rid: that.dknow.AticleId,
            UpId: that.dknow.Id
          }).then(res => {
            this.gocheck = false
            this.gocheck1 = false
            this.gocheck2 = false
            this.gocheck3 = false
            this.$router.replace({
              query: { ...this.$route.query, dkid: undefined, isbackdk: undefined }
            });
            this.$router.push({
              path: "informationDetails",
              query: {
                code: that.dknow.AticleCode,
              },
            });
          })
      }
      this.getall();
      that.showdkcg = 0;
    },
  }
}
</script>

<style lang="scss" scoped>
.container {
  position: relative;
  height: 100%;
  background-color: #f7f8fc;
  padding: 0;
  box-sizing: border-box;

  .banner {
    padding-bottom: 0.3rem;
    padding: 0.3rem 2.5%;

    .banner-swipe {
      .banner-img {
        display: block;
        width: 100%;
      }
    }
  }

  .toptab {
    display: flex;
    flex-direction: row;
    width: 54%;
    background: #f7f8fc;
    margin: auto;
    margin-top: 0.3rem;
    justify-content: space-around;
    border-radius: 50px;
    padding: 0.15rem;
  }

  .square_consult {
    width: 95%;
    margin: auto;

    .square_consult_title {
      color: #1f2b5b;
      font-size: 18px;
      font-weight: 600;
      margin: 15px 0 10px;
    }

    .square_tab_scroll {
      display: flex;
      flex-wrap: nowrap;
      overflow: auto;
      margin-bottom: 8px;
      margin-top: -6px;
      padding: 6px 0;

      .square_tab_wrapper {
        white-space: nowrap;
      }

      span {
        position: relative;
        color: #435361;
        font-size: 16px;
      }


      span:not(:first-of-type) {
        margin-left: 20px;
      }

      .active {
        color: #1D2A5A;
      }

      .active::after {
        content: "";
        position: absolute;
        left: 50%;
        bottom: -6px;
        transform: translateX(-16px);
        width: 32px;
        height: 3px;
        border-radius: 3px;
        background: #1f2b5b;
      }
    }

    /* 隐藏水平滚动条 */
    .square_tab_scroll::-webkit-scrollbar {
      display: none;
    }

    .square_consult_box {
      position: relative;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;

      .right_Consult {
        // display: flex;
        border-radius: 8px;
        // box-shadow: 0 5px 8px 0 rgba(0, 0, 0, .04);
        margin-bottom: 12px;
        // padding: 10px;
        // background-color: #FFFFFF;
        box-sizing: border-box;
        // z-index: 20;
        position: relative;
        width: 100%;
        background: #fff;
        // padding-bottom: 1rem;

        .base {
          display: flex;
          flex-direction: column;
          // justify-content: space-between;
          flex: 1;
          padding: 0 3%;
          justify-content: space-between;
          box-sizing: border-box;
          padding: 0 0 0 0.2rem;
          // position: relative;

          .red {
            color: red;
          }

          .title {
            color: #0c2941;
            font-size: 15px;
            font-weight: 500;
            line-height: 22px;
            color: #283261;
            font-weight: bold;

            .top {
              background: #1f2b5b;
              border-radius: 2px;
              font-size: 12px;
              color: #fff;
              padding: 3px;
              margin-right: 5px;
            }
          }

          .info {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 3%;
            position: absolute;
            left: 8%;
            bottom: 0.3rem;

            .source_box {
              display: flex;
              align-items: center;
              min-width: 25px;
              max-width: 70%;
              height: 25px;
              border-radius: 25px;
              background: #f6f6f6;

              .source_icon {
                width: 16px;
                height: 16px;
                border-radius: 50%;
                margin: 0 5px;
                background-color: #fff;
              }

              .source_title {
                font-size: 12px;
                color: #435361;
                margin: 0 10px 0 5px;
              }
            }

            .time {
              font-size: 12px;
              color: #435361;
            }
          }
        }

        .picture {
          flex-shrink: 0;
          width: 40%;
          border-radius: 0.16rem;
          overflow: hidden;
          position: relative;

          img {
            display: block;
            width: 100%;
            height: 100%;
          }
        }
      }
    }

    .square_consult_box {
      position: relative;

      .right_Consult1 {
        border-radius: 8px;
        margin-bottom: 12px;
        box-sizing: border-box;
        position: relative;
        width: 49%;
        background: #fff;

        .base {
          display: flex;
          flex-direction: column;
          // justify-content: space-between;
          flex: 1;
          padding: 0.15rem 3%;
          justify-content: space-between;
          // position: relative;

          .red {
            color: red;
          }

          .title {
            color: #0c2941;
            font-size: 15px;
            font-weight: 500;
            line-height: 22px;
            color: #283261;
            font-weight: bold;

            .top {
              background: #1f2b5b;
              border-radius: 2px;
              font-size: 12px;
              color: #fff;
              padding: 3px;
              margin-right: 5px;
            }
          }

          .info {
            display: flex;
            justify-content: start;
            align-items: center;
            margin-top: 3%;

            .source_box {
              display: flex;
              align-items: center;
              min-width: 25px;
              max-width: 70%;
              height: 25px;
              border-radius: 25px;
              background: #f6f6f6;

              .source_icon {
                width: 16px;
                height: 16px;
                border-radius: 50%;
                margin: 0 5px;
                background-color: #fff;
              }

              .source_title {
                font-size: 12px;
                color: #435361;
                margin: 0 10px 0 5px;
              }
            }

            .time {
              font-size: 12px;
              color: #435361;
            }
          }
        }

        .picture {
          flex-shrink: 0;
          width: 100%;
          // height: 80px;
          border-radius: 10px;
          overflow: hidden;
          // margin-left: 10px;

          img {
            display: block;
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }

  .share {
    position: fixed;
    right: 10px;
    bottom: 120px;
    width: 40px;
    height: 40px;
    z-index: 100;
  }
}

.searchrow {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
}

.srowleft {
  width: 79%;
}

.srowright {
  width: 19%;
}

.searchinput {
  width: 100%;
  border: 1px solid rgb(35, 41, 95);
  border-radius: 5px;
  padding: .1rem .2rem;
  box-sizing: border-box;
  background: rgb(247, 248, 252);
}

.searchbtn {
  width: 100%;
  border: 0;
  background: rgb(35, 41, 95);
  color: #fff;
  border-radius: 5px;
  padding: .1rem 0;
}

.square_consult_title {
  color: #1f2b5b;
  font-size: 18px;
  font-weight: 600;
  margin: 15px 0 10px;
  position: relative;
}

.ztxscroll {
  width: 100%;
  overflow-x: scroll;
  padding-bottom: 0.3rem;
  position: relative;
  z-index: 99;
  white-space: nowrap;
}

.ztx_item {
  width: 100%;
  background: #fff;
  border-radius: 0.266667rem;
  margin-right: 0.5rem;
  position: relative;
  z-index: 50;
  display: inline-block;
}

.ztximg {
  display: block;
  width: 100%;
}

.ztxrow {
  display: flex;
  flex-direction: row;
  padding: 0.3rem 0.2rem;
}

.ztxtitle {
  width: 78%;
  color: #1f2b5b;
  margin-right: 2%;
  display: flex;
  align-items: center;
}

.ztxbtnout {
  width: 20%;
  text-align: center;
}

.ztxguanzhu {
  background: #23295f;
  border: 0;
  color: #fff;
  width: 100%;
  padding: 0.2rem 0;
}

.ztmore {
  font-size: .4rem;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}

.livetiaozhuan {
  display: flex;
  flex-direction: column;
}

.livetiaozhuan1 {
  display: flex;
  flex-direction: row;
  padding: 0.2rem;
  box-sizing: border-box;
}

.yybtn {
  background: #24295f;
  color: #fff;
  font-size: .42rem;
  border: 0;
  padding: 0.05rem 0.2rem;
  z-index: 99;
  position: relative;
  border-radius: 0.08rem;
  width: 100%;
}

.yybtndisable {
  background: #24295f;
  color: #fff;
  font-size: .33rem;
  border: 0;
  padding: 0.2rem 0.12rem;
  z-index: 99;
  position: relative;
  border-radius: 0.08rem;
  width: 100%;
}

.worktype {
  bottom: 2%;
  position: absolute;
  font-size: 17px;
  color: #959595;
  right: 1%;
  z-index: 99;
}

.yytype {
  width: 30%;
  text-align: right;
}

.toptabinner {
  padding: 0.1rem 0.1rem;
  box-sizing: border-box;
  font-size: .45rem;
  color: #6E6E96;
  font-weight: bold;
  width: 50%;
  text-align: center;
}

.topact {
  background: #fff;
  color: #1D2A5A;
  border-radius: 50px;
}

.instab {
  font-size: .3rem;
  background: #F5F6FA;
  color: #435361;
  padding: 0.07rem 0.15rem;
  border-radius: 5px;
  margin-right: 0.1rem;
}

.check1 {
  position: absolute;
  left: 0;
  width: 100%;
  height: 100%;
  top: 0;
  z-index: 999;

  .checkback {
    background: rgba(0, 0, 0, 0.5);
    width: 100%;
    height: 100%;
  }

  .checkkuang {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 999999;
    background: #fff;
    width: 90%;
    border-radius: 15px;
    box-sizing: border-box;
    padding: 0.5rem;
    padding-top: 1.3rem;

    .checkicon {
      width: 20%;
      padding: 0.2rem;
      background: #fff;
      border-radius: 10rem;
      position: absolute;
      left: 50%;
      transform: translate(-50%, -50%);
      top: 0;

      .con {
        display: block;
        width: 100%;
      }
    }

    .checktitle {
      font-size: 0.5rem;
      font-weight: bold;
      text-align: center;
      margin-bottom: 0.5rem;
    }

    .checkinner {
      margin-bottom: 0.5rem;
    }
  }
}

.btrowi {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.clo {
  width: 47%;
  text-align: center;
  border-radius: 10rem;
  border: 1px solid #ddd;
  padding: 0.2rem 0;
  color: #838383;
}

.jum {
  width: 47%;
  text-align: center;
  border-radius: 10rem;
  border: 1px solid #ddd;
  padding: 0.2rem 0;
  color: #fff;
  background-image: linear-gradient(to right, rgb(75, 185, 248), rgb(39, 101, 236));
}

.cheinpt {
  margin-bottom: 0.5rem;
}

.play {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 20% !important;
  height: auto !important;
}

.bannerimg {
  width: 100%;
  display: block;
}

.modeltitle {
  width: 95%;
  margin: auto;
  border-left: 0.12rem solid #C31324;
  margin-bottom: 0.3rem;
  box-sizing: border-box;
  padding-left: 0.1rem;
}

.jt {
  font-family: cursive;
}

.modelmore {
  float: right;
  color: #283261;
  font-weight: bold;
}

.modelname {
  color: #283261;
  font-weight: bold;
}

.time {
  font-size: .35rem;
  color: #959595;
}

.btrowi {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.clo {
  width: 47%;
  text-align: center;
  border-radius: 10rem;
  border: 1px solid #ddd;
  padding: 0.2rem 0;
  color: #838383;
}

.jum {
  width: 47%;
  text-align: center;
  border-radius: 10rem;
  border: 1px solid #ddd;
  padding: 0.2rem 0;
  color: #fff;
  background-image: linear-gradient(to right, rgb(75, 185, 248), rgb(39, 101, 236));
}

.jum1 {
  width: 47%;
  text-align: center;
  border-radius: 10rem;
  border: 1px solid #ddd;
  padding: 0.2rem 0;
  color: #fff;
  background-image: linear-gradient(to right, rgb(75, 185, 248), rgb(39, 101, 236));
}

.cheinpt {
  margin-bottom: 0.5rem;
}

.yyout {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
}

.yytime {
  width: 70%;
}

.atitle {
  display: flex;
  flex-direction: row;
  width: 95%;
  margin: auto;
  background-color: #fff;
  padding-top: .1rem;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}

.modeltitle1 {
  margin-bottom: 0;
  box-sizing: border-box;
  text-align: center;
  position: relative;
  flex: 0 0 auto;
  padding: .1rem .0rem;
  margin: .1rem .2rem;
}

.modtitact {
  border-bottom: 0.12rem solid #C31324;
}

.gzmore {
  float: right;
  background: #283261;
  color: #fff;
  padding: .1em .2rem;
  border-radius: 6px;
}

.gzpicture>img {
  width: 100%;
  display: block;
}

.gz_consult {
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  touch-action: pan-x;

  &::-webkit-scrollbar {
    display: none;
  }

  -ms-overflow-style: none;
  scrollbar-width: none;
}

.gzpicture {
  position: relative;
}

.gz_consult {
  margin-bottom: .3rem;
}

.gz_consult_box {
  display: flex;
  flex-wrap: nowrap;
  gap: 12px;
  padding: 0 2.5%;
  box-sizing: border-box;
}

.gz_consult_item {
  // 关键：防止项目被压缩，保持其固有宽度
  flex-shrink: 0;
  width: 250px;
}

.dkimg {
  position: absolute;
  width: 21% !important;
  right: .1rem;
  top: 50%;
  transform: translateY(-50%);
}

.tcout {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 20;

  .tcimg {
    display: block;
    width: 80%;
    position: absolute;
    left: 50%;
    top: 45%;
    transform: translate(-50%, -50%);
    z-index: 30;

    .close {
      width: 1rem;
      height: 1rem;
      display: block;
      margin: auto;
      margin-top: 0.2rem;
    }

    img {
      display: block;
      width: 100%;
    }
  }

  .back {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 25;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
  }
}

.konwclose {
  background: #0086EC;
  color: #fff;
  margin: auto;
  padding: .2rem .5rem;
  border-radius: 13.333333rem;
  width: 35%;
  height: auto;
  text-align: center;
  font-size: .4rem;
  margin-top: .3rem;
}

.successmore {
  background: #F2D785;
  color: #B26619;
  font-weight: bold;
  text-align: center;
  width: 70%;
  margin: .3rem auto;
  padding: .2rem 0;
  border-radius: 50px;
}
</style>